module.exports = __webpack_public_path__ + "static/media/ecosystem.0ed19b2f.svg";